const DAY = 86400000;
const SGT = "+08:00";
const sgToday = () => Date.parse(`${new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Singapore" })}T00:00:00${SGT}`);
const sgDay = (d) => Date.parse(`${d}T00:00:00${SGT}`);
export const fmt = (d, opts) => new Date(sgDay(d)).toLocaleDateString("en-SG", { timeZone: "Asia/Singapore", ...opts });
export const daysUntil = (d) => Math.round((sgDay(d) - sgToday()) / DAY);
export const countdown = (n) => (n === 0 ? "Today" : n === 1 ? "Tomorrow" : n < 14 ? `In ${n} days` : `In ${Math.round(n / 7)} weeks`);
export const isUpcoming = (d) => sgDay(d) >= sgToday();
export const to12h = (t) => {
  const [h, m] = t.split(":").map(Number);
  return `${h % 12 || 12}${m ? `:${String(m).padStart(2, "0")}` : ""}${h < 12 ? "am" : "pm"}`;
};
